var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar2EventFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_17445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0C4.54076 0 4.69973 0.065848 4.81694 0.183058C4.93415 0.300269 5 0.45924 5 0.625V1.25H15V0.625C15 0.45924 15.0658 0.300269 15.1831 0.183058C15.3003 0.065848 15.4592 0 15.625 0C15.7908 0 15.9497 0.065848 16.0669 0.183058C16.1842 0.300269 16.25 0.45924 16.25 0.625V1.25H17.5C18.163 1.25 18.7989 1.51339 19.2678 1.98223C19.7366 2.45107 20 3.08696 20 3.75V17.5C20 18.163 19.7366 18.7989 19.2678 19.2678C18.7989 19.7366 18.163 20 17.5 20H2.5C1.83696 20 1.20107 19.7366 0.732233 19.2678C0.263392 18.7989 0 18.163 0 17.5V3.75C0 3.08696 0.263392 2.45107 0.732233 1.98223C1.20107 1.51339 1.83696 1.25 2.5 1.25H3.75V0.625C3.75 0.45924 3.81585 0.300269 3.93306 0.183058C4.05027 0.065848 4.20924 0 4.375 0V0ZM16.8175 3.75H3.18125C2.80625 3.75 2.5 4.03 2.5 4.375V5.625C2.5 5.97 2.805 6.25 3.18125 6.25H16.8188C17.1938 6.25 17.5 5.97 17.5 5.625V4.375C17.5 4.03 17.195 3.75 16.8175 3.75ZM14.375 8.75C14.2092 8.75 14.0503 8.81585 13.9331 8.93306C13.8158 9.05027 13.75 9.20924 13.75 9.375V10.625C13.75 10.7908 13.8158 10.9497 13.9331 11.0669C14.0503 11.1842 14.2092 11.25 14.375 11.25H15.625C15.7908 11.25 15.9497 11.1842 16.0669 11.0669C16.1842 10.9497 16.25 10.7908 16.25 10.625V9.375C16.25 9.20924 16.1842 9.05027 16.0669 8.93306C15.9497 8.81585 15.7908 8.75 15.625 8.75H14.375Z",
    fill: "#8D9AB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_17445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2EventFill);
export default __webpack_public_path__ + "static/media/calendar2-event-fill.af31dbed80f19b2a7ae8a81781d36cde.svg";
export { ForwardRef as ReactComponent };